import TeacherBreadcrumb from "./teacherBreadcrumb";
import TeacherSidebar from "./teacherSidebar";
import { useEffect, useState } from "react";
import { getTeacherById } from "../../api/teachers";
import { Link, useParams } from "react-router";
import { toast } from "sonner";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";
import TeacherEDTPage from "./teacherEdtPage";
import { getAvatarFileById } from "../../api/avatar";

const TeacherDetailsPage = () => {
  const { id } = useParams(); // On récupère l'id de l'URL
  const { selectedYear } = useAcademicYear();

  const [teacherData, setTeacherData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [avatar, setAvatar] = useState<any>(null);
  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        if (!id) throw new Error("Id introuvable dans l'URL");
        const response = await getTeacherById(id);
        setTeacherData(response?.data);
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
        // console.log("teacher data: ", response.data);
        const avatar = await getAvatarFileById("TeacherProfil", id);
        setAvatar(avatar.data);
      } catch (error: any) {
        // console.log(error);
        // Si erreur (Toast Error)
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    fetchTeacherData();
  }, []);
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {isLoading && !hasLoaded ? (
            <div className="card-body h-full">
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                {/* Page Header */}
                <TeacherBreadcrumb teacherData={teacherData} />
                {/* /Page Header */}
              </div>
              {!selectedYear?.statut && <InfosAlertYearDisabled />}
              <div className="row">
                {/* informations du professeur */}
                <TeacherSidebar teacherData={{ ...teacherData, avatar }} />
                {/* /informations du professeur */}
                <div className="col-xxl-9 col-xl-8">
                  <div className="row">
                    <div className="col-md-12"></div>
                    {/* List */}
                    <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                      <li className="nav-item">
                        <Link
                          to="#top-tab1"
                          className="nav-link active"
                          data-bs-toggle="tab"
                        >
                          <i className="ti ti-school me-2" />
                          Details Professeur
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="#top-tab2"
                          className="nav-link"
                          data-bs-toggle="tab"
                        >
                          <i className="ti ti-table-options me-2" />
                          Emplois du Temps
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="#top-tab4"
                          className="nav-link"
                          data-bs-toggle="tab"
                        >
                          <i className="ti ti-report me-2" />
                          Suivi de Cours
                        </Link>
                      </li>
                    </ul>
                    {/* /List */}
                    <div className="tab-content">
                      <div className="tab-pane" id="top-tab1">
                        {/* Address */}
                        <div className="col-xxl-6 d-flex">
                          <div className="card flex-fill">
                            <div className="card-header">
                              <h5>Address</h5>
                            </div>
                            <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                                  <i className="ti ti-map-pin-up" />
                                </span>
                                <div>
                                  <p className="text-dark fw-medium mb-1">
                                    Adresse Actuelle
                                  </p>
                                  <p>{teacherData?.adresse}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Address */}
                      </div>
                      <div className="tab-pane" id="top-tab2">
                        <TeacherEDTPage id_teacher={id} />
                      </div>
                      <div className="tab-pane" id="top-tab3"></div>
                      <div className="tab-pane" id="top-tab4"></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* /Page Wrapper */}
    </>
  );
};

export default TeacherDetailsPage;
